
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import React, { useEffect, useState } from "react";
import { useRouter } from "next/router";
import Auctions_dropdown from "../../components/dropdown/Auctions_dropdown";
import Social_dropdown from "../../components/dropdown/Social_dropdown";
import Collection_items from "../../components/collectrions/Collection_items";
import Image from "next/image";
import Link from "next/link";
import Meta from "../../components/Meta";
import { useCollectionDetailsQuery } from "../../redux/actions/collection";
import { ERROR } from "../../utils/errors";
import { Spin } from "antd";
import { BASEURL_IMG } from "../../utils/constant";
import CustomImage from "../../components/global/CustomImage";
import useTranslation from "next-translate/useTranslation";
const Collection = () => {
    const { t, lang } = useTranslation('collection');
    const [likesImage, setLikesImage] = useState(false);
    const router = useRouter();
    const pid = router.query.collection;
    const { data, isFetching, isError } = useCollectionDetailsQuery({ id: pid });
    console.log(data);
    useEffect(() => {
        if (isError) {
            ERROR('SOMETHING WENT WRONG');
        }
    }, [isError]);
    const handleLikes = () => {
        if (!likesImage) {
            setLikesImage(true);
        }
        else {
            setLikesImage(false);
        }
    };
    return (<Spin spinning={isFetching} tip="Loading...">
      <Meta title={`${pid} `}/>

      <div className="pt-[5.5rem] lg:pt-24">
        {/* <!-- Banner --> */}
        {data?.data && data?.data?.length > 0 && data?.data.map(item => (<div className="relative h-[300px] w-full">
            <CustomImage src={`${BASEURL_IMG}${item?.coverPhoto}`} fallback="/images/about/about.jpg" loaderWidth='100'/>
          
          </div>))}


        {/* <!-- Profile --> */}
        {data?.data && data?.data?.length > 0 && data?.data.map((item) => {
            const { id, title, totalItem, marketCap, owners, icon, creatorName, text, details, logo, collectionName, collectionDescription, user_id } = item;
            return (<section key={id} className="dark:bg-black bg-light-base relative pb-12 pt-28">

              {/* <!-- Avatar --> */}
              <div className="absolute left-1/2 top-0 z-10 flex -translate-x-1/2 -translate-y-1/2 items-center justify-center">
                {/* <figure className="relative h-40 w-40 dark:border-jacarta-600 rounded-xl border-[5px] border-white"> */}
                  <div className="relative w-[141px] h-[141px]">
                  <CustomImage src={`${BASEURL_IMG}${logo}`} fallback="/images/avatars/owner_3.jpg" loaderWidth='60' className="dark:border-black rounded-xl border-[5px] border-white"/>
                  </div>
                  {/* <div
                  className="dark:border-jacarta-600 bg-green absolute -right-3 bottom-0 flex h-6 w-6 items-center justify-center rounded-full border-2 border-white"
                  data-tippy-content="Verified Collection"
                >
                  {icon && (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      width="24"
                      height="24"
                      className="h-[.875rem] w-[.875rem] fill-white"
                    >
                      <path fill="none" d="M0 0h24v24H0z"></path>
                      <path d="M10 15.172l9.192-9.193 1.415 1.414L10 18l-6.364-6.364 1.414-1.414z"></path>
                    </svg>
                  )}
                </div> */}
                {/* </figure> */}
              </div>

              <div className="container mt-10">
                <div className="text-center">
                  <h2 className="font-display text-jacarta-700 mb-2 text-4xl font-medium dark:text-white">
                    {collectionName}
                  </h2>
                  <div className="mb-8">
                    <span className="text-jacarta-400 text-sm font-bold">
                      {t('by')}{" "}
                    </span>
                    <Link href={`/user/${user_id}`} className="text-accent text-sm font-bold dark:text-accent-dark capitalize ml-1 inline-block">
                      {creatorName}
                    </Link>
                  </div>

             <div className="w-full flex  justify-center">
             <div className="flex w-full lg:w-6/12">
                <div className="w-full grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-3">
                <div className="dark:bg-black dark:border-accent-dark border-jacarta-100 mb-8 inline-flex flex-wrap items-center justify-center rounded-xl border bg-white py-3">
                    
                    <div>
                    <div className="text-jacarta-700 mb-1 text-base font-bold dark:text-white">
                      {totalItem || 0}
                    </div>
                    <div className="text-2xs dark:text-jacarta-400 font-medium tracking-tight">
                      {t('items')}
                   
                  </div>
                    </div>
                </div>


                <div className="dark:bg-black dark:border-accent-dark border-jacarta-100 mb-8 inline-flex flex-wrap items-center justify-center rounded-xl border bg-white py-3">
                  <div className="">
                    <div className="text-jacarta-700 mb-1 text-base font-bold dark:text-white">
                    {owners || 0}
                    </div>
                    <div className="text-2xs dark:text-jacarta-400 font-medium tracking-tight">
                      {t('owners')}
                    </div>
                  </div>
                </div>

                <div className="dark:bg-black dark:border-accent-dark border-jacarta-100 mb-8 inline-flex flex-wrap items-center justify-center rounded-xl border bg-white py-3">
                  <div className="">
                    <div className="text-jacarta-700 mb-1 text-base font-bold dark:text-white">
                    {marketCap || 0}
                    </div>
                    <div className="text-2xs dark:text-jacarta-400 font-medium tracking-tight">
                      {t('volume')}
                    </div>
                  </div>
                </div>
                 </div>
               </div>
             </div>

                  <p className="dark:text-jacarta-300 mx-auto max-w-xl text-lg">
                    {collectionDescription}
                  </p>
                </div>
              </div>
            </section>);
        })}

        {/* <!-- end profile --> */}
      </div>
      <Collection_items />
    </Spin>);
};
export default Collection;

    async function __Next_Translate__getServerSideProps__18dc829ed9e__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/collection/[collection]',
            loaderName: 'getServerSideProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || (() => Promise.resolve({})),
          }))
        }
      }
    }
    export { __Next_Translate__getServerSideProps__18dc829ed9e__ as getServerSideProps }
  